import { Link } from "react-router-dom";
import Submenu from "./Submenu";

export default function NavbarItem(props) {
  return (
    <li className={props.button}>
      {props.route ? (
        <Link className="navbar-item-link" to={props.route}>
          {props.leftIcon} <span>{props.content}</span> {props.rightIcon}
        </Link>
      ) : (
        <Submenu
          username={props.username}
          logout={props.logout}
          leftIcon={props.leftIcon}
          rightIcon={props.rightIcon}
        />
      )}
    </li>
  );
}
